module.exports = __webpack_public_path__ + "img/masthead1.4e626ade.jpg";